<template>
  <div v-if="!emptyBody || editable">
    <card class="diagnostic-editor-card mt-4">
      <div class="card-container">
        <!-- <transition name="fade" mode="out-in"> -->
        <img
          v-if="emptyBody && editable"
          class="diagnostic-message-editor-empty-state"
          :src="emptyStateSrc"
          @click="editContent"
        />
        <div v-show="!emptyBody">
          <MaydayDiagnosticEditor
            ref="mayday-editor"
            class="col-12"
            :content-id="`${content.id}-${content.returnLanguage}`"
            :body="content.body"
            :attached-objects="content.attachedObjects"
            :editable="editable"
            @update-attached-objects="updateContent"
            @restore-version="updateContent"
            @unlink-node="unlink"
            @update-written-content="delayedUpdateContent"
            @update-content-before-destroy="$emit('flush-update-content')"
            @generate-summary="$emit('generate-summary')"
          />
        </div>
        <!-- </transition> -->
      </div>
    </card>
  </div>
</template>

<script>
import MaydayDiagnosticEditor from 'components/Editors/MaydayDiagnosticEditor';

export default {
  name: 'diagnostic-builder-editor-card',
  components: {
    MaydayDiagnosticEditor,
  },
  props: {
    content: Object,
    editable: {
      type: Boolean,
      default: true,
    },
    appLanguage: {
      type: String,
      default: 'fr',
    },
  },
  data() {
    return {
      emptyBody: true,
    };
  },
  mounted() {
    this.computeIsEmptyBody(this.content.body);
  },
  computed: {
    emptyStateSrc() {
      return require(`assets/${this.appLanguage}-diag-placeholder.png`);
    },
  },
  methods: {
    // DIRECT UPDATE
    updateContent(newContent) {
      this.$emit('update-content', {
        id: this.content.id,
        payload: newContent,
      });
    },
    unlink({ newLabel }) {
      this.$emit('unlink-node', {
        id: this.content.id,
        label: newLabel,
      });
    },
    editContent() {
      this.emptyBody = false;
      this.$nextTick(() => {
        this.$refs['mayday-editor'].focusEditor();
      });
    },
    computeIsEmptyBody(body) {
      this.emptyBody =
        !body ||
        body === '<p></p>' ||
        !!body.match(/^<p data-uid="[^"]+"><\/p>$/);
    },
    // DEBOUNCE CONTENT UPDATE
    delayedUpdateContent(newContent) {
      this.$emit('delayed-update-content', {
        id: this.content.id,
        payload: newContent,
      });
    },
  },
  watch: {
    content: {
      handler(newVal) {
        this.computeIsEmptyBody(newVal.body);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.diagnostic-editor-card {
  :deep() .card-body {
    padding: 24px;
  }
}
</style>

<style lang="scss" scoped>
.diagnostic-message-editor-empty-state {
  width: 100%;
  &:hover {
    box-shadow: 0px 10px 30px #7090b026;
    cursor: pointer;
  }
}

.grey-icon-hover-red {
  color: $grey-4-mayday;
  &:hover {
    color: $red-mayday;
    cursor: pointer;
  }
}

// TRANSITION

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.diagnostic-editor-card {
  :deep() .card-header {
    padding: 15px;
  }
}
</style>
